// Generated with util/create-component.js
import Carousel from "./Carousel";
export default Carousel;
  